import crypto from 'crypto';
import { Events } from './graphql-generated';

/**
 * generates random string of characters i.e salt
 * @function
 * @param {number} length - Length of the random string.
 */
const genRandomString = (length) => {
  return crypto
    .randomBytes(Math.ceil(length / 2))
    .toString('hex') /** convert to hexadecimal format */
    .slice(0, length); /** return required number of characters */
};

/**
 * hash password with sha512.
 * @function
 * @param {string} password - List of required fields.
 * @param {string} salt - Data to be validated.
 */
export const hashPassword = (
  password: string,
  salt: string = genRandomString(16)
): { salt: string; passwordHash: string } => {
  const hash = crypto.createHmac('sha512', salt);
  hash.update(password);
  const value = hash.digest('hex');
  return {
    salt: salt,
    passwordHash: value,
  };
};

/**
 * Generate an Md5 hash of event slug
 *
 * @param {Events} event
 * @return {*}  {string}
 */
export const genMd5HashForEventSlug = (event: Pick<Events, 'slug'>): string => {
  const hash = crypto
    .createHash('md5')
    .update(event.slug.toLowerCase())
    .digest('hex');

  return hash;
};

/**
 * validate an Md5 hash for event slug
 *
 * @param {string} md5
 * @param {Events} event
 * @return {*}  {boolean}
 */
export const isValidMd5HashForEvent = (
  md5: string,
  event: Pick<Events, 'slug'>
): boolean => {
  const validHash = crypto
    .createHash('md5')
    .update(event.slug.toLowerCase())
    .digest('hex');

  return validHash === md5;
};
